import { InvalidLink } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      class: 'size-[480px]',
    },
  },
};

export default InvalidLink;
